export const FETCH_INITIAL_TAGS_REQUEST = "FETCH_INITIAL_TAGS_REQUEST";
export const FETCH_INITIAL_TAGS_SUCCESS = "FETCH_INITIAL_TAGS_SUCCESS";
export const FETCH_INITIAL_TAGS_FAILURE = "FETCH_INITIAL_TAGS_FAILURE";

export const FETCH_AUTOCOMPLETE_TAGS_REQUEST =
  "FETCH_AUTOCOMPLETE_TAGS_REQUEST";
export const FETCH_AUTOCOMPLETE_TAGS_SUCCESS =
  "FETCH_AUTOCOMPLETE_TAGS_SUCCESS";
export const FETCH_AUTOCOMPLETE_TAGS_FAILURE =
  "FETCH_AUTOCOMPLETE_TAGS_FAILURE";



// WEBPACK FOOTER //
// ./src/actions/tags/types.js